import { render } from "./dpp-keyinsights.vue?vue&type=template&id=8b3fc8d8"
import script from "./dpp-keyinsights.js?vue&type=script&lang=js"
export * from "./dpp-keyinsights.js?vue&type=script&lang=js"

import "./dpp-keyinsights.vue?vue&type=style&index=0&id=8b3fc8d8&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__